import { Link } from "react-router-dom";
import { categories, events } from "@/mocks/site";

const iconMap: Record<string, string> = {
  all: "ri-folder-3-line",
  industry: "ri-radar-line",
  variety: "ri-movie-2-line",
  brand: "ri-briefcase-line",
  live: "ri-mic-line",
  screen: "ri-clapperboard-line",
};

export default function CategoryGrid() {
  const cats = categories.slice(1);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="container-x py-14 md:py-20">
        <div className="max-w-2xl">
          <p className="text-xs font-medium tracking-[0.2em] text-secondary-600">TOPICS / 主题分类</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按领域找你想追的那条线
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            同一件事往往横跨多个领域。先按大类进入，再顺着时间线往下读，会比零散刷片段清楚得多。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {cats.map((cat, i) => {
            const count = events.filter((e) => e.categorySlug === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/archive?category=${cat.slug}`}
                className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-400"
                style={{ animation: "fade-up 0.6s ease-out both", animationDelay: `${i * 50}ms` }}
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${iconMap[cat.slug] ?? "ri-price-tag-3-line"} text-xl`}></i>
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center justify-between gap-2">
                    <span className="font-heading text-base font-bold text-foreground-950">{cat.name}</span>
                    <span className="shrink-0 text-xs text-foreground-400">{count} 篇</span>
                  </span>
                  <span className="mt-1.5 block text-sm leading-6 text-foreground-600">{cat.desc}</span>
                </span>
              </Link>
            );
          })}

          <div className="flex items-start gap-4 rounded-lg border border-accent-300 bg-accent-50 p-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-500/25 text-accent-800">
              <i className="ri-lightbulb-flash-line text-xl"></i>
            </span>
            <span className="min-w-0">
              <span className="font-heading text-base font-bold text-foreground-950">没找到对应分类？</span>
              <span className="mt-1.5 block text-sm leading-6 text-foreground-700">
                直接把你想追的词发给我们，我们会判断是否值得做一条完整时间线。
              </span>
              <Link
                to="/about#contact"
                className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
              >
                投递线索
                <i className="ri-arrow-right-line"></i>
              </Link>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}